'use client';

import { useState, useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { sendSuscribedEmail } from './action';

function Newsletter() {
	const [email, setEmail] = useState('');
	const [loading, setLoading] = useState(false);
	const [completed, setCompleted] = useState(false);
	const input = useRef<HTMLInputElement>(null);
	const button = useRef<HTMLButtonElement>(null);

	// Utiliza useEffect para acceder a localStorage después de que el componente se haya montado
	useEffect(() => {
		const isSubscribed = window.localStorage.getItem('SUBSCRIBED');
		setCompleted(isSubscribed ? true : false);
	}, []);

	async function handleSubmit(e: React.FormEvent) {
		e.preventDefault();
		console.log('[Newsletter] Submit iniciado con email:', email);
		
		if (completed) {
			console.log('[Newsletter] Usuario ya suscrito');
			toast.warning('Ya te has suscrito recientemente.');
			setEmail('');
			if (input.current) button.current!.blur();
			return;
		}

		if (!email || !email.trim()) {
			console.log('[Newsletter] Email vacío');
			toast.error('Por favor ingresa un email válido');
			return;
		}

		setLoading(true);
		console.log('[Newsletter] Enviando solicitud...');
		
		try {
			const response = await sendSuscribedEmail({ email });
			console.log('[Newsletter] Respuesta recibida:', response);

			if (response?.error) {
				console.error('[Newsletter] Error en respuesta:', response.message);
				toast.error(response?.message || 'Error al suscribirse');
			} else {
				console.log('[Newsletter] Suscripción exitosa');
				// Mensaje especial en desarrollo
				if (process.env.NODE_ENV === 'development') {
					toast.success('¡Suscripción exitosa! (Modo desarrollo: email enviado a talleres.sclara@gmail.com)');
				} else {
					toast.success('¡Gracias por suscribirte!');
				}
				setEmail('');
				setCompleted(true);
				window.localStorage.setItem('SUBSCRIBED', 'true');
				if (input.current) input.current.blur();
			}
		} catch (error) {
			console.error('[Newsletter] Error inesperado:', error);
			toast.error('Error al procesar la suscripción');
		} finally {
			setLoading(false);
		}
	}

	return (
		<form onSubmit={handleSubmit}>
			<h2>Newsletter</h2>
			<input
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				id="newsletter-email"
				placeholder="Escribe tu correo"
				type="email"
				ref={input}
				disabled={loading}
			/>
			<button ref={button} type="submit" disabled={loading}>
				<span>Suscribirse</span>
			</button>
		</form>
	);
}

export default Newsletter;
